<template>
    <div class="contract">
        <div class="searchPart">
            <div style="display: flex; align-items: center">
                <el-input v-model="title" placeholder="操作模块"></el-input>
                <el-button class="searchBtn" @click="search">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="reset">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
            <!--      <div>
                    <el-button type="text" size="small">新增</el-button>
                  </div>-->
        </div>
        <div class="contractTable">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                class="tableContent"
            >
                <el-table-column
                    prop="title"
                    label="操作模块"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                    width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="businessTypeCn"
                    label="操作类型"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="requestMethod"
                    label="请求方式"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="operName"
                    label="操作人员"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="operIp"
                    label="操作地址"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="businessStatusCn"
                    label="操作状态"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="operTime"
                    label="操作时间"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    width="230"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="toDialog(1,scope.row)"
                        >查看
                        </el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="pagination"
                background
                @current-change="handlePageChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                :current-page="current"
                :page-size="pageSize"
                :total="total"
            >
            </el-pagination>
        </div>

        <el-dialog
            title="操作日志详细信息"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="800px"
        >
            <div class="dialogBox">
                <div class="details">
                    <div class="detailsItem">
                        <div class="itemContent">
                            <div class="one-row">
                                <div class="label">操作模块:</div>
                                <div class="name">{{sysOperLog.title}} / {{sysOperLog.businessTypeCn}}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">请求地址:</div>
                                <div class="name">{{sysOperLog.operUrl}}</div>
                            </div>
                            <div class="two-row">
                                <div class="label">登陆信息:</div>
                                <div class="name">{{sysOperLog.operName}} / {{sysOperLog.operIp}}</div>
                            </div>
                            <div class="two-row">
                                <div class="label">请求方式:</div>
                                <div class="name">{{sysOperLog.requestMethod}}</div>
                            </div>
                            <div class="two-row" style="width: 100%">
                                <div class="label">操作方法:</div>
                                <div class="name">{{sysOperLog.method}}</div>
                            </div>
                            <div class="two-row" style="width: 100%">
                                <div class="label">请求参数:</div>
                                <div class="name">{{sysOperLog.operParam}}</div>
                            </div>
                            <div class="two-row" style="width: 100%">
                                <div class="label">返回参数:</div>
                                <div class="name">{{sysOperLog.jsonResult}}</div>
                            </div>
                            <div class="two-row">
                                <div class="label">操作状态:</div>
                                <div class="name">{{sysOperLog.businessStatusCn}}</div>
                            </div>
                            <div class="two-row">
                                <div class="label">操作时间:</div>
                                <div class="name">{{sysOperLog.operTime}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import {demandListByPage, sysOperLogListByPage} from "../../utils/interface";

export default {
    name: "contract",
    data() {
        return {
            current: 0,
            pageSize: 10,
            total: 0,
            title: "",
            dialogVisible: false,
            tableData: [],
            sysOperLog: {},
            form: {systemType:'BUSINESS_MANAGER'}
        };
    },
    created() {
        this.search();
    },
    methods: {
        search() {
            this.form.title = this.title;
            this.form.current = this.current;
            this.form.pageSize = this.pageSize;
            sysOperLogListByPage(this.form).then((res)=>{
                this.tableData = [];
                console.log(res);
                if(res != null && res.list != null && res.list.length > 0){
                    this.total = res.total;
                    this.tableData = res.list;
                }else{
                    this.total = 0;
                }
            });
        },
        reset() {
            this.title = "";
        },
        // 分页
        handleCurrentChange(val) {
            this.current = val;
        },
        handlePageChange(val) {
            this.current = val;
            this.search();
        },
        toDialog(val,data) {
            this.dialogVisible = true;
            this.sysOperLog = data;
            console.log('1111',this.sysOperLog );
        },
    },
};
</script>

<style lang="less" scoped>
.searchPart {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    /deep/ .el-input {
        width: initial;
        margin-bottom: 22px;
        margin-right: 30px;
    }

    /deep/ .el-input__inner {
        width: 242px;
        height: 35px;
        min-height: 35px;
        font-size: 12px;
        color: #999999;
        background-color: #f2f4f7;
        border: 1px solid #f2f4f7;
        border-radius: 5px;

        &:hover,
        &:focus {
            background-color: #fff;
            border: 1px solid #108ee9;
        }
    }

    /deep/ .el-input__prefix {
        top: -3px;
    }

    /deep/ .el-input__suffix {
        top: 2px;
    }

    /deep/ .el-button {
        display: block;
        line-height: 35px;
        padding: 0;
        height: 35px;
    }

    .searchBtn {
        width: 82px;
        background: #3d7fff;
        border: none;
        border-radius: 15px;
        font-size: 14px;
        color: #ffffff;
        margin-bottom: 22px;
    }

    .resetBtn {
        color: #333333;
        margin-bottom: 22px;
    }
}

.contract {
    padding: 20px;
    background: #fff;
    margin-left: 15px;

    .tableContent {
        min-height: 650px;
    }
}

.pagination {
    margin-top: 20px;
    text-align: right;
}

.dialogBox {
    .details {
        .detailsItem {
            padding-bottom: 20px;
            h3 {
                font-weight: 700;
                font-size: 16px;
                color: #000;
                margin-top: 0;
                letter-spacing: 1px;
                // border-bottom: 1px solid #ddd;
                padding-bottom: 15px;
            }
            .itemContent {
                display: flex;
                flex-wrap: wrap;
                font-size: 15px;
                // padding: 0 30px;
                .one-row {
                    width: 50%;
                    margin-bottom: 22px;
                    display: flex;
                    font-size: 14px;
                    .label {
                        padding-right: 15px;
                        min-width: 95px;
                        // font-size: 14px;
                        color: rgba(0, 0, 0, 0.85);
                    }
                    .name {
                        // color: #000;
                        // font-size: 14px;
                        color: rgba(0, 0, 0, 0.65);
                    }
                }
                /deep/.nameimg  img{
                    width: 100%!important;
                }


                .two-row {
                    // width: 100%;
                    width: 50%;
                    margin-bottom: 22px;
                    display: flex;
                    font-size: 14px;
                    img{
                        width: 100%;
                    }
                    .label {
                        padding-right: 15px;
                        min-width: 95px;
                        color: rgba(0, 0, 0, 0.85);
                    }
                    .name {
                        // color: #000;
                        color: rgba(0, 0, 0, 0.65);
                        p{
                            width: 650px;
                        }

                    }
                }
            }
            .itemPictureContent {
                display: flex;
                flex-wrap: wrap;
                font-size: 15px;
                padding: 0 30px;
                justify-content: space-between;
                .one-row {
                    width: 30%;
                    margin-bottom: 22px;
                    img {
                        width: 100%;
                        height: 138px;
                        border: 1px solid #ddd;
                    }
                    .name {
                        text-align: center;
                        padding-top: 10px;
                        font-size: 14px;
                        display: flex;
                        .label {
                            min-width: 80px;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/logManage/sysOperLogList.vue